import { useEffect, RefObject } from "react";

export default function useOutsideClick(
  ref: RefObject<HTMLElement | undefined>,
  callback: () => void
) {
  const handleClick = (event: MouseEvent) => {
    const target = event.target;
    if (ref.current && target instanceof Node && !ref.current.contains(target)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
}
